import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { ILicensePlatesFormValues } from 'features/Vehicles/types'

const typeMessages = defineMessages({
  required: {
    id: 'vehiclesV2.licensePlatesForm.type.required',
    defaultMessage: 'The license type is required'
  }
})

const numberMessages = defineMessages({
  required: {
    id: 'vehiclesV2.licensePlatesForm.number.required',
    defaultMessage: 'The vehicle plate is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<ILicensePlatesFormValues> => {
  const validations = {
    licensePlates: yup.array().of(
      yup.object().shape({
        type: yup.mixed().required(intl.formatMessage(typeMessages.required)),
        number: yup.string().required(intl.formatMessage(numberMessages.required)),
        state: yup
          .object()
          .shape({
            name: yup.string().required(),
            code: yup.string().required()
          })
          .nullable()
      })
    )
  }

  return yup.object().shape(validations)
}
